document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vitaverse-banner').forEach(function (root) {
    var viewport = root.querySelector('.vitaverse-banner__viewport');
    var track = root.querySelector('.vitaverse-banner__track');
    var realSlides = root.querySelectorAll('.vitaverse-banner__slide');
    var dots = root.querySelectorAll('.vitaverse-banner__dot');
    var count = realSlides.length;
    if (count <= 1) return;

    // Clone the first slide and append it after the last real slide.
    // This lets the track keep animating rightward past the last slide;
    // once that animation finishes we silently snap back to the real
    // first slide (identical-looking), giving a seamless infinite loop.
    var firstClone = realSlides[0].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    firstClone.removeAttribute('tabindex');
    track.appendChild(firstClone);

    var index = 0; // 0..count-1 = real slides, count = the appended clone
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var timer = null;

    var dragging = false;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var baseTranslatePx = 0;
    var moved = false; // exceeded the tap/click movement threshold
    var pointerId = null;

    var TAP_THRESHOLD = 10; // px of movement still considered a tap, not a drag

    function widthPx() {
      return viewport.getBoundingClientRect().width;
    }

    function setTransform(px, animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === (index % count));
      });
    }

    function render(animate) {
      setTransform(-index * widthPx(), animate !== false);
      updateDots();
    }

    // After animating onto the cloned slide, jump back to the real
    // first slide with no transition — invisible to the viewer.
    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (index === count) {
        index = 0;
        setTransform(-0, false);
      }
    });

    function goTo(i) {
      index = i;
      setTransform(-index * widthPx(), true);
      updateDots();
    }

    function next() {
      if (index >= count) index = 0;
      index += 1; // may become `count` (the clone) — transitionend handles the wrap
      setTransform(-index * widthPx(), true);
      updateDots();
    }

    function prev() {
      index = Math.max(0, index - 1);
      setTransform(-index * widthPx(), true);
      updateDots();
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      stop();
      if (autoplay) timer = setInterval(next, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    window.addEventListener('resize', function () { render(false); });

    // Pointer-based drag / swipe (touch, mouse, pen) that also doubles
    // as a tap-to-navigate when there was no real drag. We deliberately
    // do NOT use a real <a href> wrapping the slide: on touch devices an
    // anchor covering the whole draggable area fights the browser's own
    // touch/link-callout handling and breaks manual swiping. Instead each
    // slide (optionally) carries data-link, and a real tap (movement below
    // TAP_THRESHOLD) navigates there via JS.
    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      lastX = startX;
      pointerId = e.pointerId;
      baseTranslatePx = -index * widthPx();
      track.classList.add('is-dragging');
      stop();
      try { track.setPointerCapture(pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      lastX = e.clientX;
      var deltaX = lastX - startX;
      var deltaY = e.clientY - startY;
      if (Math.abs(deltaX) > TAP_THRESHOLD || Math.abs(deltaY) > TAP_THRESHOLD) moved = true;
      // Only actually drag the track horizontally once we're confident this
      // is a horizontal gesture, so vertical page scrolling still works.
      if (moved) {
        setTransform(baseTranslatePx + deltaX, false);
      }
    });

    function currentRealSlide() {
      var i = index % count;
      return realSlides[i];
    }

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var deltaX = lastX - startX;
      var width = widthPx();
      var threshold = Math.max(40, width * 0.15);

      if (!moved) {
        // A genuine tap: no meaningful movement at all, navigate if linked.
        var slide = currentRealSlide();
        var link = slide ? slide.getAttribute('data-link') : null;
        if (link) { window.location.href = link; }
        start();
        return;
      }

      if (deltaX <= -threshold) {
        next(); // swipe left → forward (loops via the clone)
      } else if (deltaX >= threshold) {
        prev(); // swipe right → backward (stops at the first slide)
      } else {
        render(true); // snap back, not far enough to change slide
      }
      start();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Keyboard access for the tabindex="0" slides (Enter/Space to follow the link)
    realSlides.forEach(function (slide) {
      slide.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var link = slide.getAttribute('data-link');
        if (link) { e.preventDefault(); window.location.href = link; }
      });
    });

    render(false);
    start();
  });
});
